<template>
  <div
    class="no-postcss ellipsis-wrapper"
    :class="[isHidden ? 'hidden-wrapper' : 'spread-wrapper', { 'text-indent': indent }]"
    :style="{ '--text-rows': rows }"
  >
    <span class="main" v-html="text"> </span>
    <span :class="`after ${isEn ? 'en' : ''}`">
      <span class="ellipsis-dots" v-if="isHidden">...</span>
      <span class="toggle-text" :class="{ expand: isHidden, collapse: !isHidden }" @click="toggleExpand">
        {{ isHidden ? $t('展开') : $t('收起') }}
      </span>
    </span>
  </div>
</template>

<script>
import { i18nTranslateInit } from '@/utils/utility-lang'

export default {
  name: 'EllipsisText',
  props: {
    text: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 6
    },
    indent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEn() {
      return i18nTranslateInit.lang.includes('en')
    }
  },
  data() {
    return {
      isHidden: true
    }
  },
  methods: {
    toggleExpand() {
      this.isHidden = !this.isHidden
    }
  }
}
</script>

<style lang="scss" scoped>
.no-postcss.ellipsis-wrapper {
  --font-size: 14px;
  --line-height: 20px;
  --symbol-width: calc(var(--font-size) * 3);
}

.ellipsis-wrapper {
  line-height: var(--line-height);
  font-size: var(--font-size);
  word-break: break-all;
  .after {
    position: relative;
    height: var(--line-height);
    text-indent: 0;
    background: var(--bg-color-1);
  }
}
.hidden-wrapper {
  --hidden-height: calc(var(--line-height) * var(--text-rows));
  max-height: var(--hidden-height);
  overflow: hidden;
  &::before {
    float: left;
    content: '';
    width: var(--symbol-width);
    height: var(--hidden-height);
  }
  .main {
    float: right;
    width: 100%;
    margin-left: calc(var(--symbol-width) * -1);
  }
  .after {
    display: flex;
    float: right;
    width: var(--symbol-width);
    left: 97%;
    transform: translate(-100%, -100%);
    .ellipsis-dots {
      width: var(--font-size);
      background: var(--bg-color-2);
    }
    .toggle-text {
      flex: 1;
      color: var(--main-color-1);
      background: var(--bg-color-2);
      cursor: pointer;
      white-space: nowrap;
    }
  }

  .en.after {
    left: 95%;
  }
}
.spread-wrapper {
  .after {
    display: inline-flex;
    width: calc(var(--font-size) * 2);
    .toggle-text {
      flex: 1;
      color: var(--main-color-1);
      background: var(--bg-color-2);
      white-space: nowrap;
      cursor: pointer;
    }
  }
}
.text-indent {
  text-indent: calc(var(--font-size) * 2);
}
</style>
